import React from 'react'
import ItemCarousel from '../ItemCarousel/itemCarousel'
 import Capsule from '../../threeD/capsule'

 import texture1 from '../../../assets/images/capsule3.jpg'
 import texture2 from '../../../assets/images/capsule4.png'
 import texture3 from '../../../assets/images/capsule5.avif'
export default function feat_carousel() {


  
  return (
    <>
        <section className=" slider_section position-relative ">
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">

          <ol className="carousel-indicators " id='slide-indicators'>
          <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active"></li>
          <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></li>
          <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></li>
        </ol>
          <div className="carousel-inner">
            <div className="carousel-item active">
            <ItemCarousel imgBox={<Capsule directionY={0.01} texture={texture1} />} head1={'Welcome to our'} head2={'Online Medicine'}
                parag={'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don'} />
              </div>
              <div className="carousel-item ">
            <ItemCarousel imgBox={<Capsule directionY={-0.01} texture={texture2} />} head1={'Welcome to our'} head2={'Online Medicine'}
                parag={'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don'} />
            </div>
                <div className="carousel-item">
            <ItemCarousel imgBox={<Capsule directionY={0.01} texture={texture3} />} head1={'Welcome to our'} head2={'Online Medicine'}
                parag={'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don'} />
            </div>

        </div>
          <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-bs-slide="prev">
            <span className="sr-only">Previous</span>
          </a>

          <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-bs-slide="next">
            <span className="sr-only">Next</span>
          </a>
      </div>


    </section>
    </>
  )
}
